import styled from 'styled-components';

const ArticleThreadItem = styled.article`
  border-bottom: 1px solid #d1d5db;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 8px;
  padding: 8px 0;
`;

export default ArticleThreadItem;
